import { Component, OnInit, Input } from '@angular/core';
import { Documento } from '../../cliente/documento.model';
import { SnackService } from '../../shared-services/snack.service';
import { ClienteService } from '../../core/cliente.service';
import { Documentacion } from '../../cliente/documentacion.model';
import { BackendService } from '../../core/backend.service';
import { Cliente } from '../../cliente/cliente.model';
import { DialogService } from '../modals/dialog.service';
import { OperationalParametric } from '../../cliente/operationalParametric.model';
import { EstadoCliente } from '../../cliente/estadoCliente.model';

@Component({
  selector: 'app-usuario-datos-documentacion',
  templateUrl: './usuario-datos-documentacion.component.html',
  styleUrls: ['./usuario-datos-documentacion.component.scss']
})
export class UsuarioDatosDocumentacionComponent implements OnInit {
  @Input() documentacion: Documentacion[];
  @Input() estado: OperationalParametric;
  @Input() documentacionPendiente: boolean;
  private re = /(?:\.([^.]+))?$/;
  EstadoCliente = new EstadoCliente();
  private seleccionarArchivo = 'Seleccionar archivo';
  constructor(
    clienteService: ClienteService,
    private backendService: BackendService,
    private snackService: SnackService,
    private dialogService: DialogService) { }

  ngOnInit() {
  }

  agregarDocumento(indexTipoDoc: number) {
    this.documentacion[indexTipoDoc].documentos.push(new Documento(undefined));
  }
  eliminarDocumento(indexTipoDoc: number, index: number) {
    if (this.documentacion[indexTipoDoc].documentos[index].id) {
      this.dialogService.confirm('Eliminar archivo',
      '¿Está seguro que desea eliminar el documento ' + this.documentacion[indexTipoDoc].documentos[index].path
       + '?')
      .then( res => {
        if (res) {
          this.deleteFromDb(this.documentacion[indexTipoDoc].documentos[index].id);
          this.documentacion[indexTipoDoc].documentos.splice(index, 1);
          if (this.documentacion[indexTipoDoc].documentos.length === 0) {
            this.documentacion[indexTipoDoc].documentos.push(new Documento(undefined));
          }
        }
      });
    } else {
      this.documentacion[indexTipoDoc].documentos.splice(index, 1);
    }
  }
  deleteFromDb(documentoId: number) {
    this.backendService.delete(Cliente.path + 'eliminar-documento/' + documentoId);
  }
  addFile(event, indexTipoDoc: number, index: number) {
    if (this.soloImagenesOPdf(event.target.files[0].name)) {
      this.documentacion[indexTipoDoc].documentos[index].file = event.target.files[0];
      this.documentacion[indexTipoDoc].documentos[index].path = event.target.files[0].name;
      this.documentacion[indexTipoDoc].documentos[index].id = undefined;
    }
  }

  soloImagenesOPdf(fileName: string) {
    let ext = this.re.exec(fileName)[1];
    ext = ext.toLowerCase();
    if (ext !== 'png' && ext !== 'jpg' && ext !== 'pdf') {
      this.snackService.error('Solo estan permitidos archivos de tipo ".png", ".jpg" o ".pdf"');
      return false;
    }
    return true;
  }

  maxLength(indexTipoDoc: number) {
    if (this.documentacion[indexTipoDoc].documentos.length === 3) {
      return true;
    }
    return false;
  }

  async showFile(id: number) {
  }
  private openWindow(data) {
    try {
      const blob = new Blob([data], { type: data.type });
      const url = window.URL.createObjectURL(blob);
      window.open(url);
    } catch (ex) {
      console.log(ex);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shared-components/usuario-datos-documentacion/usuario-datos-documentacion.component.ts